import React from 'react';
import { AppForm, AppFormInput, AppSubmitButton } from 'components/new_components/forms';
import { labelStyles, inputStyles } from './components/styles';
import { IconButton } from '@mui/material';
import { ArrowLeft } from 'lucide-react';
import { useHistory } from 'react-router-dom';
import { socialMediaValidation } from './utils/validations';
import { UpdateBusinessUser } from 'api/general';
import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { GetBusinessUser } from 'api/general';

export default function SocialInfo() {
    const history = useHistory();

    const { data: user, refetch } = useQuery({
        queryKey: ['get-user-info'],
        queryFn: () => GetBusinessUser(),
    });

    const { linkedin_link = '', x_link = '', facebook_link = '', instagram_link = '' } = user || {};

    const { mutate, isLoading } = useMutation({
        mutationKey: ['updateBusinessUser'],
        mutationFn: UpdateBusinessUser,
        onSuccess: () => {
            toast.success('Profile updated successfully');
            refetch();
        },
        onError: (error) => {
            toast.error(error?.message || 'An error occured');
        },
    });

    return (
        <div className="bg-white min-h-[100dvh] p-3 max-w-[500px] mx-auto">
            <div>
                <IconButton
                    sx={{ padding: '8px', border: '1px solid #CBD5E1' }}
                    onClick={() => history.push('/business-profile/profile')}
                >
                    <ArrowLeft size={20} color="#254062" />
                </IconButton>
            </div>

            <div className="flex flex-col mt-4 px-1">
                <div className="block mb-4">
                    <h2 className="font-bold text-gray-700 text-2xl">Socials</h2>
                    <p className="text-sm">Input your social media link below</p>
                </div>

                <AppForm
                    initialValues={{
                        linkedin_link,
                        x_link,
                        facebook_link,
                        instagram_link,
                    }}
                    onSubmit={mutate}
                    validate={socialMediaValidation}
                >
                    <div className="flex flex-col gap-1">
                        <AppFormInput
                            label="LinkedIn"
                            name="linkedin_link"
                            placeholder="Enter your Linkedin profile link"
                            large
                            labelStyle={labelStyles}
                            sx={inputStyles}
                        />
                        <AppFormInput
                            label="Twitter (X)"
                            name="x_link"
                            placeholder="Enter your X handle (optional)"
                            large
                            labelStyle={labelStyles}
                            sx={inputStyles}
                        />
                        <AppFormInput
                            label="Facebook"
                            name="facebook_link"
                            placeholder="Enter your Facbook handle (optional)"
                            large
                            labelStyle={labelStyles}
                            sx={inputStyles}
                        />
                        <AppFormInput
                            label="Instagram"
                            name="instagram_link"
                            placeholder="Enter your instagram handle (optional)"
                            large
                            labelStyle={labelStyles}
                            sx={inputStyles}
                        />
                    </div>

                    <AppSubmitButton
                        text="Save"
                        variant="contained"
                        color="primary"
                        loadingPosition="center"
                        sx={{
                            width: '100%',
                            mt: 3,
                            padding: '12px 8px',
                            backgroundColor: '#002c72',
                            borderRadius: '8px',
                        }}
                        loading={isLoading}
                    />
                </AppForm>
            </div>
        </div>
    );
}
